// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SmallConfigTemp_temperatur__hapQX {
    flex: 1 1;
    position: relative;
}
.SmallConfigTemp_headline__o7AdS {
    align-self: stretch;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
}
.SmallConfigTemp_temperaturTag__69U1b {

    position: relative;
    display: inline-block;
}
.SmallConfigTemp_temperaturAbSonnenaufgang__T2uSS {

    position: relative;
    font-size: 10px;
    color: #757c88;
    display: inline-block;
}
.SmallConfigTemp_temperaturTagParent__cYeo\\+ {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 2px;
}
.SmallConfigTemp_div__cb8-a {
    position: relative;
}
.SmallConfigTemp_c__Wl8Tn {
    position: relative;
    color: #757c88;
}
.SmallConfigTemp_timeClockCircleStreamlineIcon__MXbc1 {
    width: 20px;
    position: relative;
    height: 20px;
    overflow: hidden;
    flex-shrink: 0;
    display: none;
}
.SmallConfigTemp_parent__41U6j {
    align-self: stretch;
    border-radius: 4px;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 6px 8px;
    font-size: 14px;
}
.SmallConfigTemp_frameContainer__e0ZUY {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 7px;
}
.SmallConfigTemp_frameGroupTemperatur__nL1dV {
    align-self: stretch;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 21px;
}
.SmallConfigTemp_erlaubteAbweichungTag__QZbGS {
    align-self: stretch;
    position: relative;
}
.SmallConfigTemp_frameChild__mF-Qk {
    width: 5.8px;
    position: relative;
    height: 3.2px;
}
.SmallConfigTemp_frameParentTemperatur__x-4ve {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 15px;
}
.SmallConfigTemp_graphIcon__4CCNx {
    align-self: stretch;
    position: relative;
    max-width: 100%;
    overflow: hidden;
    height: 160px;
    flex-shrink: 0;
    object-fit: cover;
}
.SmallConfigTemp_config__m-2ha {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 30px;
    font-size: 12px;
    color: #cbd6e9;
}
.SmallConfigTemp_cardTemperatur__fNI-Q {
    width: 100%;
    position: relative;
    border-radius: 6px;
    background-color: #0f141c;
    border: #d9e9ea 1px solid;
    box-sizing: border-box;
    height: 720px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 20px;
    gap: 30px;
    min-width: 300px;
    max-width: 380px;
    text-align: left;
    font-size: 21px;
    color: #fff;
    font-family: 'Noto Sans';
}

`, "",{"version":3,"sources":["webpack://./src/css/SmallConfigTemp.module.css"],"names":[],"mappings":"AAAA;IACI,SAAO;IACP,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;AAC3B;AACA;;IAEI,kBAAkB;IAClB,qBAAqB;AACzB;AACA;;IAEI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,QAAQ;AACZ;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,kBAAkB;;IAElB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,QAAQ;AACZ;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,SAAS;AACb;AACA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,SAAS;AACb;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,SAAS;IACT,eAAe;IACf,cAAc;AAClB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,sBAAsB;IACtB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,wBAAwB;AAC5B","sourcesContent":[".temperatur {\n    flex: 1;\n    position: relative;\n}\n.headline {\n    align-self: stretch;\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: center;\n}\n.temperaturTag {\n\n    position: relative;\n    display: inline-block;\n}\n.temperaturAbSonnenaufgang {\n\n    position: relative;\n    font-size: 10px;\n    color: #757c88;\n    display: inline-block;\n}\n.temperaturTagParent {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    gap: 2px;\n}\n.div {\n    position: relative;\n}\n.c {\n    position: relative;\n    color: #757c88;\n}\n.timeClockCircleStreamlineIcon {\n    width: 20px;\n    position: relative;\n    height: 20px;\n    overflow: hidden;\n    flex-shrink: 0;\n    display: none;\n}\n.parent {\n    align-self: stretch;\n    border-radius: 4px;\n\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    padding: 6px 8px;\n    font-size: 14px;\n}\n.frameContainer {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    gap: 7px;\n}\n.frameGroupTemperatur {\n    align-self: stretch;\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: flex-start;\n    gap: 21px;\n}\n.erlaubteAbweichungTag {\n    align-self: stretch;\n    position: relative;\n}\n.frameChild {\n    width: 5.8px;\n    position: relative;\n    height: 3.2px;\n}\n.frameParentTemperatur {\n    align-self: stretch;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    gap: 15px;\n}\n.graphIcon {\n    align-self: stretch;\n    position: relative;\n    max-width: 100%;\n    overflow: hidden;\n    height: 160px;\n    flex-shrink: 0;\n    object-fit: cover;\n}\n.config {\n    align-self: stretch;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    gap: 30px;\n    font-size: 12px;\n    color: #cbd6e9;\n}\n.cardTemperatur {\n    width: 100%;\n    position: relative;\n    border-radius: 6px;\n    background-color: #0f141c;\n    border: #d9e9ea 1px solid;\n    box-sizing: border-box;\n    height: 720px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    padding: 20px;\n    gap: 30px;\n    min-width: 300px;\n    max-width: 380px;\n    text-align: left;\n    font-size: 21px;\n    color: #fff;\n    font-family: 'Noto Sans';\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"temperatur": `SmallConfigTemp_temperatur__hapQX`,
	"headline": `SmallConfigTemp_headline__o7AdS`,
	"temperaturTag": `SmallConfigTemp_temperaturTag__69U1b`,
	"temperaturAbSonnenaufgang": `SmallConfigTemp_temperaturAbSonnenaufgang__T2uSS`,
	"temperaturTagParent": `SmallConfigTemp_temperaturTagParent__cYeo+`,
	"div": `SmallConfigTemp_div__cb8-a`,
	"c": `SmallConfigTemp_c__Wl8Tn`,
	"timeClockCircleStreamlineIcon": `SmallConfigTemp_timeClockCircleStreamlineIcon__MXbc1`,
	"parent": `SmallConfigTemp_parent__41U6j`,
	"frameContainer": `SmallConfigTemp_frameContainer__e0ZUY`,
	"frameGroupTemperatur": `SmallConfigTemp_frameGroupTemperatur__nL1dV`,
	"erlaubteAbweichungTag": `SmallConfigTemp_erlaubteAbweichungTag__QZbGS`,
	"frameChild": `SmallConfigTemp_frameChild__mF-Qk`,
	"frameParentTemperatur": `SmallConfigTemp_frameParentTemperatur__x-4ve`,
	"graphIcon": `SmallConfigTemp_graphIcon__4CCNx`,
	"config": `SmallConfigTemp_config__m-2ha`,
	"cardTemperatur": `SmallConfigTemp_cardTemperatur__fNI-Q`
};
export default ___CSS_LOADER_EXPORT___;
